import { config } from "@/lib/config";
import {
  ThemeProvider as NextThemesProvider,
  useTheme as useNextTheme,
  type ThemeProviderProps as NextThemeProviderProps,
} from "next-themes";
import type { ReactNode } from "react";

export const themes = ["dark", "light", "system"] as const;
export type Theme = (typeof themes)[number];

type ThemeProviderProps = {
  children: ReactNode;
} & Pick<NextThemeProviderProps, "forcedTheme">;

/**
 * ThemeProvider wires system preference, localStorage, and the html class
 * strategy used by semantic tokens in main.css.
 */
export default function ThemeProvider({
  children,
  forcedTheme,
}: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      storageKey={`${config.key}.theme`}
      defaultTheme="system"
      enableSystem
      forcedTheme={forcedTheme}
    >
      {children}
    </NextThemesProvider>
  );
}

export function useTheme() {
  const { resolvedTheme, setTheme, systemTheme, theme } = useNextTheme();

  return {
    theme: (theme ?? "system") as Theme,
    setTheme: (nextTheme: Theme) => setTheme(nextTheme),
    systemTheme,
    resolvedTheme,
  };
}
